export default __webpack_public_path__ + "static/life-grid-pink-min-99665d2c4dda4b4346c579293e594ab8.png";